import { render, staticRenderFns } from "./TipGroupForm.vue?vue&type=template&id=2767eaff&"
import script from "./TipGroupForm.vue?vue&type=script&lang=ts&"
export * from "./TipGroupForm.vue?vue&type=script&lang=ts&"
import style0 from "./TipGroupForm.vue?vue&type=style&index=0&id=2767eaff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports